export default __webpack_public_path__ + "static/media/cat.0b8a601e.png";